export const defaultLoadingPaneSpinnerStyles = {
  width: "42px",
  height: "42px",
  margin: "0px 0px 0px 0px",
  display: "flex",
  order: 4,
  alignSelf: "auto"
};